
import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { errorStyles } from '../../Utils/table';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { AdminSaleMenu, onlyAdminSaleMenu, UserSaleMenu } from '../TitleList';
import { fetchStudentData, fetchZoneData } from '../../Store/PHPSlice/zone';
import { selectlocationdata, selectLocations, selectStockItems, selectStudents, selectZones } from '../Selectors/Master/OutwardSelectors';
import { fetchStockItemlist } from '../../Store/PHPSlice/StkInw';
import { insertUserSaleEntry } from '../../Store/PHPSlice/stockApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';


const UserSaleEntry = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    // console.log(userdata);

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedRows, setSelectedRows] = useState([]);

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        memo: '',
        studNm: '',
        firmId: '',
        schlId: '',
        div: '',
        std: '',
        item: '0',
        totqty: '0',
        totamt: '0',
        schl_stkId: '',
        adsaleId: '',
        totIssqty: '0',
        totqty: '0',
        totprate: '0',
        totsrate: '0',
        totIssqty2: '0',
        totqty2: '0',
        totprate2: '0',
        totsrate2: '0',
        totamt: '0',
        totamt2: '0',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '0',
        gst_type: 'no',
        gst: 0,
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '0',
        discnt_val: '0',
        netamt: '0',
        trans: '',
        remark: '',
        shipto: '',
        shipadrs: '',
        type: '',
        paymode: '',
        bnkNm: '',
        transId: '',
        payamt: '',
        userId: userdata?.ID
    });
    const [items, setItems] = useState([]);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        studNm: fetchStudentData
        // Add more mappings if needed
    };

    const [tableData, setTableData] = useState([]);
    const [multiItems, setMultiItems] = useState([]);
    const [adsaleData, setAdsaleData] = useState([]);
    const [userSchldata, setUserSchldata] = useState([]);
    const [activeMenu, setActiveMenu] = useState(AdminSaleMenu);
    const dispatch = useDispatch();

    const partyList = [];
    const itemList = [];
    const zonedata = useSelector(selectZones);
    const stkdata = useSelector(selectStockItems);
    const students = useSelector(selectStudents);
    const schldata = useSelector(selectLocations);
    const firmlist = useSelector(selectFirm);
    // console.log(schldata)


    useEffect(() => {
        dispatch(fetchZoneData());
        dispatch(fetchStockItemlist());
        fetchUserSaleMemo();

        dispatch(fetchLocationData());
        dispatch(fetchCompanyData());
        if (userdata?.role !== '1') {
            dispatch(fetchStudentData({ userId: userdata?.ID }));
        } else {
            dispatch(fetchStudentData());
        }
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (dropdown === 'studNm') {
                    if (action && userdata?.role === '2') {
                        dispatch(action({ userId: userdata?.ID }));
                    } else {
                        dispatch(action());
                    }
                } else {
                    if (action) {
                        dispatch(action());
                    }
                }

            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (!userdata) return;

        if (userdata?.udata && userdata?.schlwise === false) {
            const val = userdata?.ID;
            // fetchBillNosSchlwise({ userId: val });
            setFormData(prev => ({
                ...prev,
                type: 'userId'
            }));
        } else if (userdata?.role === '1') {
            setFormData(prev => ({
                ...prev,
                type: 'userId'
            }));
        }

        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(onlyAdminSaleMenu);
                // console.log('hhi')
            } else if (userdata?.role === '2') {
                setActiveMenu(UserSaleMenu);
            } else {
                setActiveMenu(AdminSaleMenu);
            }
            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 3);
            // console.log(selectpid);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
        if (userdata?.ID) {
            fetchUserWiseItems(userdata?.ID);
        }
    }, []);

    useEffect(() => {
        if (tableData?.length > 0) {
            const prev_totamt = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totamt || 0), 0);
            const totamt = tableData?.reduce((acc, sum) => acc + parseFloat(sum.total || 0), 0);
            const final_totamt = totamt;

            if (formData.gst_type === '1') {
                const discnt_amt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(final_totamt));
                let grandtot = parseFloat(final_totamt) - discnt_amt;
                let cgst, igst, sgst;
                let gst_val = Math.round(grandtot * (parseFloat(formData.gst !== '' ? formData.gst : 5) / 100));
                if (formData.state_type === '1') {
                    igst = gst_val;
                } else {
                    const half_gst = Math.round(gst_val / 2).toFixed(2);
                    cgst = half_gst;
                    sgst = half_gst;
                }
                setFormData(prev => ({
                    ...prev,
                    totamt: final_totamt || 0,
                    discnt_amt: discnt_amt || 0,
                    grandtot: grandtot || 0,
                    totamt2: totamt || 0,
                    gst_val: gst_val,
                    igst: igst || 0,
                    cgst: cgst || 0,
                    sgst: sgst || 0
                }));
            } else {

                let grandtot = parseFloat(final_totamt);
                let cgst, igst, sgst;
                let gst_val = Math.round(grandtot * (parseFloat(formData.gst) / 100));
                if (formData.state_type === '1') {
                    igst = gst_val;
                } else {
                    const half_gst = Math.round(gst_val / 2).toFixed(2);
                    cgst = half_gst;
                    sgst = half_gst;
                }
                setFormData(prev => ({
                    ...prev,
                    totamt: final_totamt,
                    grandtot: grandtot,
                    totamt2: totamt,
                }));
            }
        }
    }, [tableData]);

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];
    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        { label: 'Other Charges', name: 'other_ch' },
        { label: 'Gross Total', name: 'grandtot', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];

    const fields12 = {
        'Cheque': {
            label: 'Bank Name',
            name: 'bnkNm'
        }
    };
    const fields13 = fields12[formData.paymode];

    const fields14 = [
        { label: 'Pay Amount', name: 'payamt' },
    ];
    const paymodelist = [
        { label: 'Cash', value: 'Cash' },
        { label: 'Cheque', value: 'Cheque' },
        { label: 'NEFT', value: 'NEFT' },
        { label: 'IMPS', value: 'IMPS' },
        { label: 'Phone Pay', value: 'Phone-Pay' },
        { label: 'G-Pay', value: 'GPay' },
        { label: 'Paytm', value: 'Paytm' },
        { label: 'Bhim-UPI', value: 'Bhim-UPI' }
    ];


    const fields10 = {
        'Cheque': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'NEFT': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'IMPS': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'RTGS': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Phone-Pay': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'GPay': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Paytm': {
            label: 'Transaction ID.',
            name: 'transId'
        },
        'Bhim-UPI': {
            label: 'Transaction ID.',
            name: 'transId'
        }
    };

    const fields11 = fields10[formData.paymode];


    const dropdownlistfirst = [
        {
            label: 'Payment Mode',
            id: 'paymode',
            options: paymodelist || [],
            value: formData.paymode,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'paymode', value: newValue ? newValue.value : '' } }, 'paymode'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },
        }
    ];


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const fetchSchlItems = async (id) => {
        const { schlId1, userId1 } = id;
        console.log("schld", schlId1);
        console.log("userId", userId1);

        try {
            const response = await axios.get(`${baseUrl}?apicall=getSchlStockItems&schlId=${schlId1}&userId=${userId1}`);
            setItems(response.data.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchUserWiseItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSchlStockItems&userId=${id}`);
            setItems(response.data.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchSchlStkData = async (id) => {
        const { stkId, itemId, userId } = id;
        try {
            // const response = await axios.get(`${baseUrl}?apicall=getSchlStockInwData&stkId=${id}`);
            const response = await axios.get(`${baseUrl}?apicall=getAdminStkItemwise&stkId=${stkId}&itemId=${itemId}&userId=${userId}`);

            setAdsaleData(response?.data?.info);
            // console.log(`${baseUrl}?apicall=getAdminStkItemwise&stkId=${stkId}&itemId=${itemId}`);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchUserSaleMemo = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserSaleMemo`);
            const memos = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                memo: memos?.memo
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    // const fetchUserSchlData = async (userId) => {
    //     try {

    //         let endpoint = `getSchlWiseBills&userId=${userId}`;

    //         const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);

    //         setUserSchldata(response?.data?.data);

    //         // console.log(response.data);

    //     } catch (error) {
    //         console.error('Error fetching info list:', error);
    //     }
    // };


    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setUserSchldata(response.data.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'size':
                if (value) {
                    let selectObj = adsaleData?.find((val) => val.ID === value);
                    console.log(selectObj)
                    if (selectObj) {
                        const isAlreadyAdded = tableData.some(item => item.ID === selectObj.ID);

                        if (!isAlreadyAdded) {

                            setTableData(prev => [...prev, selectObj]);

                            setFormData({
                                ...formData,
                                size: ''
                            });
                        } else {
                            alert("This item is already Exists.");
                            setFormData({
                                ...formData,
                                size: ''
                            });
                        }
                    }
                };
                break;
            case 'item':
                if (value) {
                    const selectObj = items?.find(itm => itm.ID === value);
                    // console.log(items)
                    const stkId = selectObj?.stkId;
                    // console.log(selectObj)
                    const data = {
                        itemId: value,
                        stkId: selectObj?.id,
                        userId: userdata?.ID
                    };
                    // console.log(data)

                    fetchSchlStkData(data);
                } else {
                    setAdsaleData([]);
                }
                break;
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 / parseFloat(value)) || 0;
                        netamt = igst + grandtot2 || 0;
                    } else {
                        const diff = Math.round(grandtot2 / parseFloat(value)) || 0;
                        cgst = Math.round(diff / 2) || 0;
                        sgst = Math.round(diff / 2) || 0;
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt || 0
                    }));
                };
                break;
            case 'schlId':
                if (value) {
                    const data = {
                        schlId1: value,
                        userId1: userdata?.ID
                    };
                    console.log("data12=>", data);
                    fetchSchlItems(data);
                } else {
                    fetchUserWiseItems(userdata?.ID);
                }
                //  console.log(students?.data,"students from user sale entry ");
                break;

            default:
                break;
        };
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
        switch (name) {
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    const updatedData = [...tableData];
                    const cal_data = updatedData?.map((item) => {
                        const discal = Math.round((parseFloat(value) / 100) * item?.srate);
                        const disrate = parseFloat(item?.srate) - parseFloat(discal);
                        return {
                            ...item,
                            disrate: disrate
                        };
                    });
                    setTableData(cal_data);
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * (parseFloat(formData.gst) / 100));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                };
                break;
        }
    };

    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            // console.log(update_gross)
            let igst = 0, cgst = 0, sgst = 0, gst = 5;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(gst) / 100));
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: gst
            }));

        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(formData.gst) / 100));
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: '0'
            }));
        }
    };

    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 / parseFloat(value));
                        netamt = igst + grandtot2;
                    } else {
                        const diff = Math.round(grandtot2 / parseFloat(value));
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let final_grand = grandtot2 + parseFloat(value) + other_ch;
                    setFormData(prev => ({
                        ...prev,
                        grandtot: final_grand
                    }));
                    if (formData.gst_type === 'yes') {
                        let gst_cal, igst, cgst, sgst;

                        gst_cal = Math.round(final_grand * (parseFloat(formData.gst) / 100));

                        if (formData.state_type == '1') {
                            igst = gst_cal;
                        } else {
                            cgst = Math.round(gst_cal / 2);
                            sgst = Math.round(gst_cal / 2);
                        }

                        let netamt = final_grand + gst_cal;
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst || 0,
                            cgst: cgst || 0,
                            sgst: sgst || 0,
                            netamt: netamt
                        }));

                    }
                }
                break;
            case 'other_ch':
                if (value) {

                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * (parseFloat(formData.discnt_val) / 100));
                    const grandtot2 = Math.round(total_amt - gst_amt);
                    const freight_ch = formData.freight_ch !== "" ? parseFloat(formData.freight_ch) : 0;
                    const final_grand = grandtot2 + parseFloat(value) + freight_ch;

                    if (formData.gst_type === 'yes') {
                        let gst_cal = parseFloat((final_grand * (parseFloat(formData.gst) / 100)).toFixed(2));
                        let igst = 0, cgst = 0, sgst = 0;

                        if (formData.state_type === '1') {
                            igst = gst_cal;
                        } else {
                            cgst = parseFloat((gst_cal / 2).toFixed(2));
                            sgst = parseFloat((gst_cal / 2).toFixed(2));
                        }

                        let netamt = Math.round((final_grand + gst_cal))
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand,
                            igst: igst,
                            cgst: cgst,
                            sgst: sgst,
                            netamt: netamt
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            grandtot: final_grand
                        }));
                    }

                }
                break;

        };
    }

    const handleChange = (index, field, value) => {
        const updatedData = [...tableData];

        if (field === 'issqty') {
            const enteredQty = parseFloat(value || 0);
            const availableQty = parseFloat(updatedData[index].bqty || 0);
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const disrate = parseFloat(updatedData[index].disrate || 0);
            if (enteredQty > availableQty) {
                alert("Issued quantity cannot be greater than available quantity (bqty).");
                return; // Don't update the state
            }
            const total = enteredQty * disrate;
            updatedData[index][field] = enteredQty;
            const diff = availableQty - enteredQty;
            updatedData[index].bal_qty = Math.round(diff);
            updatedData[index].total = Math.round(total);
            setTableData(updatedData);
            const totissqty = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
            const prevIss = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totIssqty), 0);
            const totamt = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.total), 0);
            const netamt = totamt + parseFloat(formData.igst) + parseFloat(formData.sgst) + parseFloat(formData.cgst);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totqty: totissqty,
                totamt: totamt,
                netamt: netamt
            }));
        };
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows((prevSelected) =>
            prevSelected.includes(index)
                ? prevSelected.filter((i) => i !== index)
                : [...prevSelected, index]
        );
    };

    const handleDeleteSelected = () => {
        const newData = tableData.filter((_, index) => !selectedRows.includes(index));
        const totamt = newData?.reduce((acc, sum) => acc + parseFloat(sum.total), 0);
        const netamt = totamt + parseFloat(formData.igst) + parseFloat(formData.sgst) + parseFloat(formData.cgst);
        // Update the total quantity
        setFormData(prev => ({
            ...prev,
            totamt: totamt,
            netamt: netamt
        }));
        setTableData(newData); // Make sure you have setTableData state function
        setSelectedRows([]);   // Clear selection
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertIntoOneObject(formData, tableData) {
        const selectItem = items?.find(val => val.ID === formData.item);
        const itemid = selectItem?.itemId;
        const itemnm = selectItem?.itemNm;
        const totamt = formData.netamt !== '0' ? formData.netamt : formData.grandtot;
        const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
        // const discnt_type = formData.discnt_type;
        const gst_type = formData.gst_type === 'yes' ? '1' : '0';
        const data = {
            dt: formData.dt,
            memo: formData.memo,
            studNm: formData.studNm,
            firmId: formData.firmId,
            schlId: formData.schlId,
            div: formData.div,
            std: formData.std,
            itemId: formData.item,
            totqty: formData.totqty,
            totamt: formData.totamt,
            userId: formData.userId,
            schstkId: formData.schl_stkId,
            adsaleId2: formData.adsaleId,
            discnt_type: discnt_type,
            discnt_val: formData.discnt_val,
            discnt_amt: formData.discnt_amt,
            freight_ch: formData.freight_ch,
            other_ch: formData.other_ch,
            party_state: formData.state_type,
            gst: gst_type,
            gst_val: formData.gst,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            netamt: totamt,
            tableData: tableData,
            payamt: formData.payamt,
            bankNm: formData.bnkNm,
            paymode: formData.paymode,
            transId: formData.transId
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.firmId === '') {
            alert('Select Firm');
            return; // Stop form submission
        }
        if (formData.studNm === '') {
            alert('Select Student');
            return; // Stop form submission
        }
        if (formData.payamt === '') {
            alert('Enter Payableamt');
            return; // Stop form submission
        }
        if (formData.paymode === '') {
            alert('Select Payment mode');
            return; // Stop form submission
        }
        // if (formData.schlId === '') {
        //     alert('Select School');
        //     return; // Stop form submission
        // }
        if (!tableData || tableData.length === 0) {
            alert('Please select items'); // Capitalize message if desired
            return;
        }

        const postObj = convertIntoOneObject(formData, tableData);
        // console.log(postObj);

        dispatch(insertUserSaleEntry(postObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("User Sale Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleItemNew = () => {
        window.open(`/new-student-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Student',
            id: 'studNm',
            // options: (students?.data || []).filter(student =>
            //     !formData?.schlId || student.schlId === formData.schlId
            // ),
            options: (students?.data || []),
            value: formData.studNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'studNm', value: newValue ? newValue.ID : '' } }, 'studNm'),
            getOptionLabel: (option) => option.studNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
            handleAddNew: () => handleItemNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('studNm'),
            handleDropdownClose: () => handleDropdownClose('studNm'),
        },
        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? userSchldata : schldata?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,

        },
        {
            label: 'Item',
            id: 'item',
            options: items || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Size',
            id: 'size',
            options: adsaleData || [],
            value: formData.size,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'size', value: newValue ? newValue.ID : '' } }, 'size'),
            getOptionLabel: (option) => option.size || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    const gstvalues = [
        { label: '3', ID: 3 },
        { label: '5', ID: 5 },
        { label: '12', ID: 12 },
        { label: '18', ID: 18 }
    ];

    const dropdownGst = [
        {
            label: 'GST(%)',
            id: 'gst',
            options: gstvalues,
            value: formData.gst,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'gst', value: newValue ? newValue.ID : '' } }, 'gst'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    return (
        <>
            {/* <Titlebar data={userdata?.role === '2' ? UserSaleMenu : AdminSaleMenu} /> */}
            <Titlebar data={activeMenu} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>User Sale Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No.', name: 'memo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {[
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <RadioComponent
                                    label='GST'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {formData.gst_type === 'yes' ?

                                    <>
                                        {/* {gstField.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))} */}

                                        {
                                            dropdownGst?.map((drop) => (
                                                <Dropdown
                                                    key={drop.label}
                                                    label={drop.label}
                                                    id={drop.id}
                                                    options={drop.options}
                                                    value={drop.value}
                                                    onChange={drop.onChange}
                                                    isDesktop={isDesktop}
                                                    getOptionLabel={drop.getOptionLabel}
                                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                />
                                            ))
                                        }

                                    </>
                                    : (
                                        <Grid item xs={12} md={6}>

                                        </Grid>
                                    )
                                }

                                {fields2?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                            <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                {opts_discnt_amt.map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        value={option.value}
                                                        control={<Radio />}
                                                        label={option.label}
                                                    />
                                                ))}
                                                
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                <TextField
                                                    id="discnt_val"
                                                    name="discnt_val"
                                                    value={formData.discnt_val}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.inputs }}
                                                    sx={inputNumbersmall}
                                                />
                                                <TextField
                                                    id="discnt_amt"
                                                    name="discnt_amt"
                                                    value={formData.discnt_amt}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input, readOnly: true }}
                                                    sx={inputStyle11}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {fields21?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}

                                {formData.gst_type === 'yes' &&
                                    <>
                                        {
                                            fields4?.map((field) => (
                                                <DateInputComponent
                                                    key={field.name}
                                                    formData={formData}
                                                    handleDateChange={handleDateChange}
                                                    handleInputChange={handleInputChange}
                                                    styled={styled}
                                                    inputStyles={inputStyles}
                                                    isDesktop={isDesktop}
                                                    field={field}
                                                />
                                            ))
                                        }
                                    </>
                                }

                                {fields14?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                        handleInputComplete={handleInputComplete}
                                    />
                                ))}


                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    fields11 &&
                                    <DateInputComponent
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={fields11}
                                    />
                                }

                                {
                                    fields13 &&
                                    <DateInputComponent
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={fields13}
                                    />
                                }

                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleDeleteSelected}
                                    disabled={selectedRows.length === 0}
                                    style={{ marginTop: '16px' }}
                                >
                                    Delete
                                </Button>



                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Discount(%)</TableCell> */}
                                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell> */}
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bal Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.length > 0
                                                        ? tableData?.map((form, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell>
                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.discnt_val}</TableCell> */}
                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell> */}
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <input type="text"
                                                                        value={form.issqty || ''}
                                                                        name='issqty'
                                                                        onChange={(e) => handleChange(index, 'issqty', e.target.value)}
                                                                        style={{ height: '25px', width: '60px' }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bal_qty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.total}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                }



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UserSaleEntry;
